import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Log error to console for debugging
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoBack = () => {
    window.history.back();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
          <Card className="max-w-lg w-full">
            <CardContent className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                  <AlertTriangle className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold text-slate-800">
                    Произошла ошибка
                  </h2>
                  <p className="text-slate-500 text-sm">
                    Что-то пошло не так при загрузке страницы
                  </p>
                </div>
              </div>
              
              {this.state.error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                  <p className="text-sm font-medium text-red-800 mb-1">
                    Детали ошибки:
                  </p>
                  <code className="text-xs text-red-700 break-all">
                    {this.state.error.toString()}
                  </code>
                </div>
              )}
              
              {this.state.errorInfo && (
                <div className="mb-4 p-3 bg-slate-100 rounded-lg max-h-40 overflow-auto">
                  <p className="text-sm font-medium text-slate-700 mb-1">
                    Stack trace:
                  </p>
                  <pre className="text-xs text-slate-600 whitespace-pre-wrap">
                    {this.state.errorInfo.componentStack}
                  </pre>
                </div>
              )}
              
              <div className="flex gap-3">
                <Button 
                  onClick={this.handleReload}
                  className="flex-1 gap-2"
                >
                  <RefreshCw className="w-4 h-4" />
                  Перезагрузить
                </Button>
                <Button 
                  onClick={this.handleGoBack}
                  variant="outline"
                  className="flex-1"
                >
                  Назад
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
